import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import Register from "./register";
import Login from "./login";
import ForgotPassword from "./forgot-password";
import WalletModal from "./wallet";
import ChatRules from "./chat-rules";
import ModalVip from "./vip";
import {useSearchParams} from "react-router-dom";
import store from "../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../actions/global-actions";
import Statistics from "./statistics";
import BetDetailModal from "./bet-detail";
import RaffleModal from "./raffle";
import RaceModal from "./race";
import CampaignCreateModal from "./campaign";
import WalletSettings from "./wallet-settings";
import BetsModal from "./bets";
import TipDetailModal from "./tip-detail";
import RainModal from "./rain";
import BonusModal from "./bonus-detail";
import VaultModal from "./vault";
import BonusRequestModal from "./bonus-request";
import WheelModal from "./wheel/wheel";
import UnifyBalances from "./unify-balances";
import WheelPrizeModal from "./wheel/prize";

const ModalsIndex = () => {

    const {modalType, theme} = useSelector(state => state.globalReducer)
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        document.body.setAttribute('data-theme', theme)
    }, [theme])


    const handleClose = () => {

        searchParams.delete('modal');
        searchParams.delete('tab');
        searchParams.delete('currency');
        searchParams.delete('reference');
        searchParams.delete('ref');
        searchParams.delete('user');
        searchParams.delete('username');
        searchParams.delete('type');
        searchParams.delete('uuid');
        setSearchParams(searchParams);


        store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))
    }

    const handleModalAction = (type) => setSearchParams({modal: type})

    // const checkText = () => {
    //     const tabsNavElements = document.querySelectorAll('.tabs-nav--modal');
    //
    //     console.log('tabsNavElements = ',tabsNavElements)
    //     if (tabsNavElements.length === 0) {
    //         return;
    //     }
    //
    //     function getTabsWidth(tabItems) {
    //         let totalWidth = 0;
    //         for (let i = 0; i < tabItems.length; i++) {
    //             totalWidth += tabItems[i].offsetWidth;
    //         }
    //         return totalWidth;
    //     }
    //
    //     function checkTabsWidth(tabsNav) {
    //         const tabItems = tabsNav.children;
    //         const tabsNavWidth = tabsNav.offsetWidth;
    //         const totalTabsWidth = getTabsWidth(tabItems);
    //
    //         if (totalTabsWidth <= tabsNavWidth) {
    //             tabsNav.classList?.add('tabs-nav--space');
    //         } else {
    //             tabsNav.classList?.remove('tabs-nav--space');
    //         }
    //     }
    //
    //     function processAllTabsNav() {
    //         tabsNavElements.forEach(tabsNav => {
    //             checkTabsWidth(tabsNav);
    //         });
    //     }
    //
    //     window.addEventListener('resize', processAllTabsNav);
    //
    //     const modalElements = document.querySelectorAll('.modal');
    //
    //     modalElements.forEach(modal => {
    //         modal.addEventListener('shown.bs.modal', processAllTabsNav);
    //     });
    // }
    //
    // useEffect(() => {
    //     setTimeout(() => checkText(), 1500)
    //
    // }, [modalType])

    const getActiveModal = () => {
        switch (modalType) {
            case 'register':
                return <Register
                    handleModalAction={handleModalAction}
                    handleClose={handleClose}/>

            case 'login':
                return <Login
                    handleModalAction={handleModalAction}
                    handleClose={handleClose}/>

            case 'forgot-password':
                return <ForgotPassword
                    handleModalAction={handleModalAction}
                    handleClose={handleClose}
                />


            case 'wallet':
                return <WalletModal
                    handleClose={handleClose}
                />

            case 'vault':
                return <VaultModal
                    handleClose={handleClose}
                />


            case 'bonus-request':
                return <BonusRequestModal
                    handleClose={handleClose}
                />


            case 'rain':
                return <RainModal
                    handleClose={handleClose}
                />


            case 'raffle':
                return <RaffleModal
                    handleClose={handleClose}
                />

            case 'race':
                return <RaceModal
                    handleClose={handleClose}
                />

            case 'statistics':
                return <Statistics
                    handleClose={handleClose}
                />

            case 'chat-rules':
                return <ChatRules/>


            case 'bets':
                return <BetsModal handleClose={handleClose}/>


            case 'vip':
                return <ModalVip
                    handleClose={handleClose}
                />

            case 'tip':
                return <TipDetailModal
                    handleClose={handleClose}
                />

            case 'bonus-detail':
                return <BonusModal
                    handleClose={handleClose}
                />


            case 'bet':
                return <BetDetailModal
                    handleClose={handleClose}
                />

            case 'campaign':
                return <CampaignCreateModal
                    handleClose={handleClose}
                />


            case 'wallet-settings':
                return <WalletSettings
                    handleClose={handleClose}
                />

            case 'wheel':
                return <WheelModal
                    handleClose={handleClose}
                />
            case 'wheel-prize':
                return <WheelPrizeModal
                    handleClose={handleClose}
                />

            case 'unify-balances':
                return <UnifyBalances
                    handleClose={handleClose}
                />


            default:
                return null
        }
    }

    return getActiveModal()
}

export default React.memo(ModalsIndex)
